import { useDataChange } from 'Simple/Data'

export function useOnChange(props) {
  let change = useDataChange({
    context: 'comparison',
    viewPath: props.viewPath,
  })

  return function onChange() {
    change(next => {
      next.orientation =
        next.orientation === 'horizontal' ? 'vertical' : 'horizontal'
    })
  }
}
